
import TodoHandler from "../Database/handlers/TodoHandler";
import { ITodo, TodoObj } from "../types/interfaces";
const todoHandler = new TodoHandler()

export default async function FetchAndCreateTodoLists(project:string,sortingArr?:string[][]) {
  let PendingTodosSortIDs: number[] = []
  let OngoingTodosSortIDs:number[] = []
  let CompletedTodosSortIDs:number[] = []
  let PendingTodosIDs: string[] = []
  let OngoingTodosIDs:string[] = []
  let CompletedTodosIDs:string[] = []
  const TodosList = await todoHandler.FetchTodosLists(project)
  
  console.log(TodosList)
  
  
  TodosList.forEach((listObj:ITodo,i) => {
    switch (listObj?.status) {
      case "Pending":
        PendingTodosIDs.push(listObj.id?.toString() || "")
        PendingTodosSortIDs.push(listObj.sortOrder||PendingTodosSortIDs.length)
        break;
      case "Ongoing":
        OngoingTodosIDs.push(listObj.id?.toString() || "")
        OngoingTodosSortIDs.push(listObj.sortOrder||0)
        break;
      case "Completed":
        CompletedTodosIDs.push(listObj.id?.toString() || "")
        CompletedTodosSortIDs.push(listObj.sortOrder||0)
        break;
      default:
        break;
    }
  });

  
  PendingTodosIDs = SortByIndexes(PendingTodosIDs, PendingTodosSortIDs)
  OngoingTodosIDs = SortByIndexes(OngoingTodosIDs,OngoingTodosSortIDs)
  CompletedTodosIDs = SortByIndexes(CompletedTodosIDs,CompletedTodosSortIDs)
  
  // if (sortingArr) {
  //   console.log(PendingTodosIDs,PendingTodosSortIDs)
  //   PendingTodosIDs.sort((a,b)=>sortingArr[0].indexOf(a)-sortingArr[0].indexOf(b))
  //   OngoingTodosIDs.sort((a, b) => sortingArr[1].indexOf(a) - sortingArr[1].indexOf(b))
  //   CompletedTodosIDs.sort((a,b)=>sortingArr[2].indexOf(a)-sortingArr[2].indexOf(b))
  // }

  let TodosData = {
        todos : TodosList,
        columns:{
          "Pending":{id:"Pending",title:"Pending",taskIDs:PendingTodosIDs},
          "Ongoing":{id:"Ongoing",title:"Ongoing",taskIDs:OngoingTodosIDs},
          "Completed":{id:"Completed",title:"Completed",taskIDs:CompletedTodosIDs}
        },
        columnOrder : ["Pending","Ongoing","Completed"]
  }
  return TodosData
}

function SortByIndexes(arr:string[],sortArr:number[]){
    let temp:string[] = []
    arr.forEach(()=>temp.push(""))
    arr.forEach((item,i)=>{
      temp.splice(sortArr[i],1,item)
    })
    return temp
}